import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideTertiaireStub } from '../../../../config/aides-tertiaire';

export default function TertiaireCeeBatPage() {
  const aide = getAideTertiaireStub('cee-bat');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="tertiaire" />;
}
